'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _elementHelper = require('../elements/elementHelper');

var _boardConstants = require('../boards/boardConstants');

var _cardConstants = require('../cards/cardConstants');

exports.default = function (elementType) {
    if ((0, _elementHelper.isBoardLike)(elementType)) return _boardConstants.BOARD_TYPE;

    if ((0, _elementHelper.isCard)(elementType) || (0, _elementHelper.isLink)(elementType) || (0, _elementHelper.isColumn)(elementType)) return _cardConstants.CARD_TYPE;

    return elementType;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/adjustElementType.js
// module id = 2256
// module chunks = 0